exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\nperfect-scrollbar {\n  width: auto;\n  height: calc(600px - (75px + 100px)); }\nperfect-scrollbar .page-panel {\n    padding: 10px 30px 30px 30px !important; }\n.asset-renderer.artwork-renderer {\n  margin-bottom: 30px;\n  width: 150px; }\n.page-container {\n  padding: 0 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/apply-background-dialog/apply-background-dialog.component.scss
// module id = ../../../../../src/app/shared/components/apply-background-dialog/apply-background-dialog.component.scss
// module chunks = main